import React from 'react'
import styles from './styles.less'
import PresenceButtonLabel from './Label'
import PresenceDropdown from '../Dropdown'

export default function PresenceButton({
  onSettingChange,
  onPresenceChange,
  autoAwaySetting,
  autoOfflineSetting,
  autoPresenceSetting,
  presence,
}) {
  return (
    <PresenceDropdown
      onSettingChange={onSettingChange}
      onPresenceChange={onPresenceChange}
      autoAwaySetting={autoAwaySetting}
      autoOfflineSetting={autoOfflineSetting}
      autoPresenceSetting={autoPresenceSetting}
      presence={presence}
      trigger={
        <div className={styles.button}>
          Profile status: <PresenceButtonLabel presence={presence} />
        </div>
      }
    />
  )
}
